





































































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import httpApi from "@/API/Tenant/Weixin";
import { format } from "path";
//import App from "@/components/Global/GetAppData"; //缓存接口
import Enum from "@/components/Global/enumerate"; //全局常量
import { WxVoid } from "@/Entity"; //全局常量
import utils from "@/store/utils"; //工具类
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import Bus from "@/JS/Bus";
@Component({
  components: {}
})
export default class extends Vue {
  $message: any;
  //注入数据 @Provide()
  @Prop()
  private AddaccountForm: WxVoid | any; //定义数据在WxVoid里
  private FileBase64: any;
  private Accept = "audio/mpeg, audio/x-wav, audio/x-ms-wma"; //上传文件支持格式
  private VoiceTitleLabel = "语音标题：";
  private VoiceLinkLabel = "语音链接：";
  private VoiceHighLinkLabel = "高品质音乐链接：";
  private DescriptionLabel = "语音描述：";
  private placeholder = "请输入地址或上传文件";
  private NatureStr =
    "永久素材：可以同步微信素材库；临时素材：不能同步微信素材库";
  //浏览图片相关
  private viewImage = false;
  private picture = {
    url: "",
    height: ""
  };
  private switchState = true;
  private GetAppData: any = []; //取应用号信息
  @Provide()
  //验证数据
  data() {
    //验证网址
    let isValidateURL = (
      rule: any,
      value: string,
      callback: { (arg0: Error): void; (): void }
    ) => {
      if (!utils.validateURL(value)) {
        return callback(new Error("请输入正确的网址"));
      } else {
        callback();
      }
    };

    //验证必填字段
    return {
      rules: {
        Keyword: [
          { required: true, message: "请输入关键词", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        Type: [
          { required: true, message: "请选择消息类型", trigger: "change" }
        ],
        State: [
          { required: true, message: "请选择状态类型", trigger: "change" }
        ],
        Nature: [
          { required: true, message: "请选择素材类型", trigger: "change" }
        ],
        ReallyImage: [
          {
            required: true,
            message: "请输入图片地址或上传图片",
            trigger: "blur"
          },
          { validator: isValidateURL }
        ],
        VoiceTitle: [
          { required: true, message: "请输入关键词", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        // VoiceLink: [
        //   {
        //     required: false,
        //     message: "请输入地址或上传",
        //     trigger: "blur"
        //   },
        //   { validator: isValidateURL }
        // ],
        // HighLink: [
        //   {
        //     required: false,
        //     message: "请输入地址或上传",
        //     trigger: "blur"
        //   },
        //   { validator: isValidateURL }
        // ],
        Contents: [{ required: true, message: "请输入内容", trigger: "blur" }]
      }
    };
  }
  //取消方法
  cancle() {
    this.$emit("backtable");
  }
  //切换媒体类型
  toggleTab(param: number) {
    //console.log(param);
    this.Accept = "audio/mpeg, audio/x-wav, audio/x-ms-wma"; //上传文件支持格式
    if (param == 2) {
      this.Accept = "video/mp4,video/x-msvideo,video/mpeg,audio/x-ms-wmv"; //上传文件支持格式
    }
    if (this.AddaccountForm.Nature == 1) {
      this.NatureStr = "可以同步微信素材库";
      if (this.AddaccountForm.Type == 2) {
        this.NatureStr =
          this.NatureStr +
          "，这里上传官方审核时间较长或不审核，强烈建议在公众号平台上传视频素材";
      }
    } else {
      this.NatureStr = "不能同步微信素材库";
    }
    switch (param) {
      case 1:
        this.VoiceTitleLabel = "语音标题：";
        this.VoiceLinkLabel = "语音链接：";
        this.DescriptionLabel = "语音描述：";
          this.VoiceHighLinkLabel = "文件Id(选填):";
        break;
      case 2:
        this.VoiceTitleLabel = "视频标题：";
        this.VoiceLinkLabel = "视频链接：";
        this.VoiceHighLinkLabel = "视频初始地址：";
        this.DescriptionLabel = "视频描述：";
        break;
      case 3:
        this.VoiceTitleLabel = "音乐标题：";
        this.VoiceLinkLabel = "音乐链接：";
        this.VoiceHighLinkLabel = "高品质音乐链接(选填)：";
        this.DescriptionLabel = "音乐描述：";
        break;
    }
  }
  //查看图片
  onViewImage(imageUrl: string) {
    if (imageUrl) {
      this.viewImage = true;
      var img_url = imageUrl;
      var img = new Image();
      img.src = img_url;
      this.picture.height = Math.ceil((img.height / img.width) * 570) + "px";
      this.picture.url = imageUrl;
    }
  }
  //上传之前的校验
  async onBeforeUploadImage(file: any) {
    const isIMAGE = file.type === "image/jpeg" || "image/jpg" || "image/png";
    const isLt1M = file.size / 1024 / 1024 < 2;
    if (!isIMAGE) {
      this.$message.error("上传文件只能是图片格式!");
      return;
    }
    if (!isLt1M) {
      this.$message.error("上传文件大小不能超过 2MB!");
      return;
    }
    return isIMAGE && isLt1M;
  }

  //上传图片
  async UploadImage(param: any) {
    let reader = new FileReader();
    // let that = this
    reader.readAsDataURL(param.file);
    console.log(param);
    reader.onload = async e => {
      if (e.target) {
        let obj: any = (e.target as any).result;
        let params: any = {
          Input: [
            {
              Name: "Type",
              value: param.data.Type //"AppReplyVoice"AppReplyGraphic
            },
            {
              Name: "FileName",
              value: param.file.name
            },
            {
              Name: "FileBase64",
              value: obj
            }
          ]
        };
        console.log(params);
        var res: any = await httpApi.GetUpload(params);
        console.log(res);
        if (res.ErrorCode == 0) {
          switch (param.data.Field) {
            case "ReallyImage":
              this.AddaccountForm.ReallyImage = res.output[0].value;
              break;
            case "VoiceLink":
              this.AddaccountForm.VoiceLink = res.output[0].value;
              break;
            case "HighLink":
              this.AddaccountForm.HighLink = res.output[0].value;
              break;
          }
        } else {
          this.$message.error(res.ErrorMessage);
        }
      }
    };
  }
  //初始化
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
     var that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", (obj:any) => {
      that.GetAppData.Aid=obj.Aid;      
    });
    if (this.AddaccountForm.State == 1) {
      this.switchState = true;
    } else {
      this.switchState = false;
    }
    //console.log(this.AddaccountForm);

    this.toggleTab(this.AddaccountForm.Type);
    if (this.AddaccountForm.VoiceId != 0 && this.AddaccountForm.Nature == "1") {
      this.placeholder = "如需修改址请上传再推送";
    }
  }
  //保存数据
  async SavaTextData() {
    (this as any).$refs["AddaccountForm"].validate(async (valid: boolean) => {
      if (valid) {
        if (
          (this.AddaccountForm.VoiceId == 0 ||
            this.AddaccountForm.Nature != "1") &&
          !this.AddaccountForm.VoiceLink
        ) {
          this.$message.error("必须上传文件资源！");
          return;
        }
        var _this = this;
        let AppAccount = this.GetAppData;
        if (AppAccount) {
          this.AddaccountForm.ApplicationId = AppAccount.Aid;
          this.AddaccountForm.TenantId = AppAccount.TenantID;
          if (this.switchState) {
            this.AddaccountForm.State = 1;
          } else {
            this.AddaccountForm.State = 0;
          }
          //this.AddaccountForm.Type = 1;
          //保存的数据 传参
          if (this.AddaccountForm.VoiceId) {
            this.AddaccountForm.ActionName = "UPDATE"; //修改方法
          } else {
            this.AddaccountForm.ActionName = "CREATE"; //新增方法
          }

          let params: any = {
            Input: [
              {
                Name: "AppReplyVoiceDTO",
                value: this.AddaccountForm
              }
            ]
          };
          var res: any = await httpApi.Savevoid(params);
          if (res.ErrorCode == 0) {
            this.$message.success("保存成功!");
            //保存成功后传个刷新方法过去
            _this.$emit("refresh");
          } else {
            this.$message.error("保存失败：" + res.ErrorMessage);
          }
        }
      } else {
        this.$message.error("请认真填写必填项！");
      }
    });
  }
}
